import { Component, OnInit, Inject, Optional } from '@angular/core';
import { RailroadSubCode } from 'src/shared/api';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { railroadSubCodeFormConfig } from '../railroad-sub-code.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
	selector: 'rpshared-railroad-sub-code-dialog',
	templateUrl: './railroad-sub-code-dialog.component.html',
})
export class RailroadSubCodeDialogComponent extends SelfDestruct
	implements OnInit {
	// CVA components can only be listened to through a form control
	control = new FormControl('') as FormControl;

	group = this.fb.group(railroadSubCodeFormConfig) as FormGroup;

	constructor(
		@Inject(MAT_DIALOG_DATA)
		@Optional()
		private readonly railroadSubCode: RailroadSubCode,
		private readonly fb: FormBuilder
	) {
		super();
	}

	ngOnInit() {
		this.control.valueChanges
			.pipe(filter(Boolean), takeUntil(this.destroyed))
			.subscribe((v) => this.group.setValue(v));

		if (this.railroadSubCode) {
			this.control.setValue(this.railroadSubCode);
		}
	}
}
